 export const GET_RYFT_PAYMENT_TOKEN_REQUEST = 'GET_RYFT_PAYMENT_TOKEN_REQUEST';
export const GET_RYFT_PAYMENT_TOKEN_SUCCESS = 'GET_RYFT_PAYMENT_TOKEN_SUCCESS';
export const GET_RYFT_PAYMENT_TOKEN_FAILURE = 'GET_RYFT_PAYMENT_TOKEN_FAILURE';
export const GET_RYFT_PAYMENT_TOKEN  = 'GET_RYFT_PAYMENT_TOKEN ';
export const CANCEL_BOOKING_MUTATION = 'CANCEL_BOOKING_MUTATION'
export const BOOKING_FEEDBACK_MUTATION = 'BOOKING_FEEDBACK_MUTATION'